require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-el-banco-mundial-y-los-riesgos-del-cambio-climatico.json") })
        }
      }, "path---es-mx-update-el-banco-mundial-y-los-riesgos-del-cambio-climatico");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-el-banco-mundial-y-los-riesgos-del-cambio-climatico!./.cache/json/es-mx-update-el-banco-mundial-y-los-riesgos-del-cambio-climatico.json
// module id = 928
// module chunks = 231608221292675